import React, { useState } from 'react'
import {Box, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,} from '@chakra-ui/react'
import CustomButton from './customButton'
import { Document, Page } from 'react-pdf';
export default function OpenFileDialogAdmin(props) {
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const PopupBox = () => (
        <Box >
            <ModalOverlay />
            <ModalContent className="verfyiborrowpicture">
                {/* <ModalHeader className="modal_title font-poppins">User Photo</ModalHeader> */}
                <ModalCloseButton />
                <ModalBody>
                    <Box className='pdf_read_modal  verify_image-div' >
                        {props?.fileType === 'pdf' ?
                            <Document file={props?.modalData} onLoadSuccess={onDocumentLoadSuccess}>
                                {/* <Page pageNumber={1} /> */}
                                {Array.from(new Array(numPages), (el, index) => (
                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                ))}
                            </Document>
                            : 
                            <Image src={props?.modalData} className='verify_image' />
                        }
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <CustomButton size="md" type="submit" title="Cancel" className="btn_theme" onClick={props.handleimageOpen} />
                </ModalFooter>
            </ModalContent>
        </Box>
    )

  return (
    <Modal
    isCentered
    onClose={props.handleimageOpen}
    isOpen={props.imageopen}
    motionPreset="slideInBottom"
    >
    {PopupBox()}
    </Modal>
  )
}
